import React, { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { RefreshToken } from "./auth-reducer/auth-service";
import { SignalRUrl } from "../utils/config/config";
import { useSelector } from "react-redux";
export const Context = React.createContext();
export const ContextProvider = ({ children }) => {
  const [hubConnection, setHubConnection] = useState(0);
  const { authtoken } = useSelector((state) => state.auth);

  useEffect(() => {
    if (authtoken) {
      const createHubConnection = async () => {
        let token = authtoken;
        const hubConnect = new signalR.HubConnectionBuilder()
          .withUrl(SignalRUrl, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
            accessTokenFactory: () => token,
          })
          .withAutomaticReconnect()
          .build();

        const handleTokenExpiration = async () => {
          try {
            await RefreshToken();
            hubConnect.accessTokenFactory = () => token;
          } catch (error) {}
        };

        try {
          await hubConnect.start();
        } catch (err) {
          await handleTokenExpiration();
          try {
            await hubConnect.start();
          } catch (retryErr) {}
        }

        hubConnect.onclose(async (error) => {
          await new Promise((resolve) => setTimeout(resolve, 5000));
          createHubConnection();
        });

        setHubConnection(hubConnect);
      };

      createHubConnection();
    }
    return () => {
      if (hubConnection) {
        hubConnection.stop();
      }
    };
  }, [authtoken]);

  return (
    <Context.Provider value={{ hubConnection, setHubConnection }}>
      {children}
    </Context.Provider>
  );
};
